/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { SubmissionStatus } from './SubmissionStatus';
import {
    SubmissionStatusFromJSON,
    SubmissionStatusFromJSONTyped,
    SubmissionStatusToJSON,
    SubmissionStatusToJSONTyped,
} from './SubmissionStatus';
import type { SubmissionFeedback } from './SubmissionFeedback';
import {
    SubmissionFeedbackFromJSON,
    SubmissionFeedbackFromJSONTyped,
    SubmissionFeedbackToJSON,
    SubmissionFeedbackToJSONTyped,
} from './SubmissionFeedback';
import type { SubmissionChannel } from './SubmissionChannel';
import {
    SubmissionChannelFromJSON,
    SubmissionChannelFromJSONTyped,
    SubmissionChannelToJSON,
    SubmissionChannelToJSONTyped,
} from './SubmissionChannel';
import type { Confidence } from './Confidence';
import {
    ConfidenceFromJSON,
    ConfidenceFromJSONTyped,
    ConfidenceToJSON,
    ConfidenceToJSONTyped,
} from './Confidence';
import type { CurrentReading } from './CurrentReading';
import {
    CurrentReadingFromJSON,
    CurrentReadingFromJSONTyped,
    CurrentReadingToJSON,
    CurrentReadingToJSONTyped,
} from './CurrentReading';

/**
 * 
 * @export
 * @interface SubmissionSummary
 */
export interface SubmissionSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    code: string;
    /**
     * 
     */
    receivedAt: Date;
    /**
     * 
     */
    channel: SubmissionChannel;
    /**
     * 
     */
    status: SubmissionStatus;
    /**
     * 
     */
    fromNumber: string;
    /**
     * 
     */
    senderName: string | null;
    /**
     * 
     */
    speciesScientific: string | null;
    /**
     * 
     */
    speciesCommon: string | null;
    /**
     * 
     */
    speciesScore: number | null;
    /**
     * 
     */
    speciesConfidence: Confidence | null;
    /**
     * 
     */
    lengthMm: number | null;
    /**
     * 
     */
    girthMm: number | null;
    /**
     * 
     */
    weightLowG: number | null;
    /**
     * 
     */
    weightHighG: number | null;
    /**
     * 
     */
    sizeConfidence: Confidence | null;
    /**
     * 
     */
    photoUrl: string | null;
    /**
     * 
     */
    thumbUrl: string | null;
    /**
     * 
     */
    feedback: SubmissionFeedback | null;
    /**
     * 
     */
    current: CurrentReading;
    /**
     * 
     */
    correctionCount: number;
    /**
     * 
     */
    capturedAt: Date | null;
    /**
     * 
     */
    capturedAtOffset: string | null;
    /**
     * 
     */
    latitude: number | null;
    /**
     * 
     */
    longitude: number | null;
}



/**
 * Check if a given object implements the SubmissionSummary interface.
 */
export function instanceOfSubmissionSummary(value: object): value is SubmissionSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if ((!('receivedAt' in (value as Record<string, any>)) && !('received_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['receivedAt'] === undefined && (value as Record<string, any>)['received_at'] === undefined)) return false;
    if (!('channel' in value) || value['channel'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if ((!('fromNumber' in (value as Record<string, any>)) && !('from_number' in (value as Record<string, any>))) || ((value as Record<string, any>)['fromNumber'] === undefined && (value as Record<string, any>)['from_number'] === undefined)) return false;
    if ((!('senderName' in (value as Record<string, any>)) && !('sender_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['senderName'] === undefined && (value as Record<string, any>)['sender_name'] === undefined)) return false;
    if ((!('speciesScientific' in (value as Record<string, any>)) && !('species_scientific' in (value as Record<string, any>))) || ((value as Record<string, any>)['speciesScientific'] === undefined && (value as Record<string, any>)['species_scientific'] === undefined)) return false;
    if ((!('speciesCommon' in (value as Record<string, any>)) && !('species_common' in (value as Record<string, any>))) || ((value as Record<string, any>)['speciesCommon'] === undefined && (value as Record<string, any>)['species_common'] === undefined)) return false;
    if ((!('speciesScore' in (value as Record<string, any>)) && !('species_score' in (value as Record<string, any>))) || ((value as Record<string, any>)['speciesScore'] === undefined && (value as Record<string, any>)['species_score'] === undefined)) return false;
    if ((!('speciesConfidence' in (value as Record<string, any>)) && !('species_confidence' in (value as Record<string, any>))) || ((value as Record<string, any>)['speciesConfidence'] === undefined && (value as Record<string, any>)['species_confidence'] === undefined)) return false;
    if ((!('lengthMm' in (value as Record<string, any>)) && !('length_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMm'] === undefined && (value as Record<string, any>)['length_mm'] === undefined)) return false;
    if ((!('girthMm' in (value as Record<string, any>)) && !('girth_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['girthMm'] === undefined && (value as Record<string, any>)['girth_mm'] === undefined)) return false;
    if ((!('weightLowG' in (value as Record<string, any>)) && !('weight_low_g' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightLowG'] === undefined && (value as Record<string, any>)['weight_low_g'] === undefined)) return false;
    if ((!('weightHighG' in (value as Record<string, any>)) && !('weight_high_g' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightHighG'] === undefined && (value as Record<string, any>)['weight_high_g'] === undefined)) return false;
    if ((!('sizeConfidence' in (value as Record<string, any>)) && !('size_confidence' in (value as Record<string, any>))) || ((value as Record<string, any>)['sizeConfidence'] === undefined && (value as Record<string, any>)['size_confidence'] === undefined)) return false;
    if ((!('photoUrl' in (value as Record<string, any>)) && !('photo_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['photoUrl'] === undefined && (value as Record<string, any>)['photo_url'] === undefined)) return false;
    if ((!('thumbUrl' in (value as Record<string, any>)) && !('thumb_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['thumbUrl'] === undefined && (value as Record<string, any>)['thumb_url'] === undefined)) return false;
    if (!('feedback' in value) || value['feedback'] === undefined) return false;
    if (!('current' in value) || value['current'] === undefined) return false;
    if ((!('correctionCount' in (value as Record<string, any>)) && !('correction_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['correctionCount'] === undefined && (value as Record<string, any>)['correction_count'] === undefined)) return false;
    if ((!('capturedAt' in (value as Record<string, any>)) && !('captured_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['capturedAt'] === undefined && (value as Record<string, any>)['captured_at'] === undefined)) return false;
    if ((!('capturedAtOffset' in (value as Record<string, any>)) && !('captured_at_offset' in (value as Record<string, any>))) || ((value as Record<string, any>)['capturedAtOffset'] === undefined && (value as Record<string, any>)['captured_at_offset'] === undefined)) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function SubmissionSummaryFromJSON(json: any): SubmissionSummary {
    return SubmissionSummaryFromJSONTyped(json, false);
}

export function SubmissionSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'receivedAt': (json['received_at'] == null ? json['received_at'] : parseDateTime(json['received_at'])),
        'channel': SubmissionChannelFromJSON(json['channel']),
        'status': SubmissionStatusFromJSON(json['status']),
        'fromNumber': json['from_number'],
        'senderName': json['sender_name'],
        'speciesScientific': json['species_scientific'],
        'speciesCommon': json['species_common'],
        'speciesScore': json['species_score'],
        'speciesConfidence': ConfidenceFromJSON(json['species_confidence']),
        'lengthMm': json['length_mm'],
        'girthMm': json['girth_mm'],
        'weightLowG': json['weight_low_g'],
        'weightHighG': json['weight_high_g'],
        'sizeConfidence': ConfidenceFromJSON(json['size_confidence']),
        'photoUrl': json['photo_url'],
        'thumbUrl': json['thumb_url'],
        'feedback': SubmissionFeedbackFromJSON(json['feedback']),
        'current': CurrentReadingFromJSON(json['current']),
        'correctionCount': json['correction_count'],
        'capturedAt': (json['captured_at'] == null ? null : parseDateTime(json['captured_at'])),
        'capturedAtOffset': json['captured_at_offset'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function SubmissionSummaryToJSON(json: any): SubmissionSummary {
    return SubmissionSummaryToJSONTyped(json, false);
}

export function SubmissionSummaryToJSONTyped(value?: SubmissionSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'received_at': value['receivedAt'] == null ? value['receivedAt'] : serializeDateTime(value['receivedAt']),
        'channel': SubmissionChannelToJSON(value['channel']),
        'status': SubmissionStatusToJSON(value['status']),
        'from_number': value['fromNumber'],
        'sender_name': value['senderName'],
        'species_scientific': value['speciesScientific'],
        'species_common': value['speciesCommon'],
        'species_score': value['speciesScore'],
        'species_confidence': ConfidenceToJSON(value['speciesConfidence']),
        'length_mm': value['lengthMm'],
        'girth_mm': value['girthMm'],
        'weight_low_g': value['weightLowG'],
        'weight_high_g': value['weightHighG'],
        'size_confidence': ConfidenceToJSON(value['sizeConfidence']),
        'photo_url': value['photoUrl'],
        'thumb_url': value['thumbUrl'],
        'feedback': SubmissionFeedbackToJSON(value['feedback']),
        'current': CurrentReadingToJSON(value['current']),
        'correction_count': value['correctionCount'],
        'captured_at': value['capturedAt'] == null ? value['capturedAt'] : serializeDateTime(value['capturedAt']),
        'captured_at_offset': value['capturedAtOffset'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

